import { api, ApiRequestConfig } from './api';
import { PickupAddressParams, PickupAddressResponse } from 'types/pickup-address';

const convertToPickupAddressQuery = (params: PickupAddressParams): Record<string, string> => {
  const query: Record<string, string> = {};

  if (params.storeId) {
    query.storeId = String(params.storeId);
  }

  if (params.pointId) {
    query.pointId = params.pointId;
  }

  return query;
};

export const getPickupAddress = (params: PickupAddressParams, config: ApiRequestConfig) =>
  api.get<PickupAddressResponse>('pickup-address', convertToPickupAddressQuery(params), config);
